import greenCheck from "../assets/ui/ui-confirmation.svg";
import greenCheck1 from "../assets/ui/ui-green-check.svg";
import gasPump from "../assets/gasPump.svg";
import seatbelt from "../assets/seatbelt.svg";
import speedometer from "../assets/spedometer.svg";
import wrench from "../assets/wrench.svg";
import camberPass from "../assets/camberBlankPass.svg";
import camberFail from "../assets/camberBlankFail.svg";
import toePass from "../assets/toeBlankPass.svg";
import toeFail from "../assets/toeBlankFail.svg";
import tireNormal from "../assets/tireNormalWear.svg";
import tireToeWearLeft from "../assets/toeWearTireLeft.svg";
import tireToeWearRight from "../assets/toeWearTireRight.svg";
import tireCamberWearLeft from "../assets/tireTestLeft.svg";
import tireCamberWearRight from "../assets/tireTest.svg";
import toe1 from "../assets/wear-toe/toeWearTire1.svg";
import toe2 from "../assets/wear-toe/toeWearTire2.svg";
import toe3 from "../assets/wear-toe/toeWearTire3.svg";
import toe4 from "../assets/wear-toe/toeWearTire4.svg";
import camber1 from "../assets/wear-camber/camberWearTire1.svg";
import camber2 from "../assets/wear-camber/camberWearTire2.svg";
import camber3 from "../assets/wear-camber/camberWearTire3.svg";
import camber4 from "../assets/wear-camber/camberWearTire4.svg";

export default {

  pageTitle: "Understanding Alignment",
  tabSizing: "smallerTab",

  camberContent: {
    intro: "Camber angle is inward or outward wheel tilt. When it is out of manufacturer specifications, your vehicle will experience increased tire wear, decreased stopping distance and poor handling.",
    introPopup: "Touch and slide the arrows back and forth to change the camber alignment.",
    camberDefinition: "<p>Camber is the inward or outward tilt of the wheel and tire when viewed from the front or back of your vehicle.<br><br>Camber can go out of specifications over time due to normal wear and tear or impact with various obstacles in the road.<br><br>Off-road or aggressive use can accelerate camber angle issues.</p>",
    passengerSlider: "Front passenger-side camber",
    driverSlider: "Front driver-side camber",
    passImage: camberPass,
    failImage: camberFail,
    tireImage: tireNormal,
    tireCamberWearLeft: tireCamberWearLeft,
    tireCamberWearRight: tireCamberWearRight,
    camber1: camber1,
    camber2: camber2,
    camber3: camber3,
    camber4: camber4,
    disclaimer: "Image is exaggerated for demonstration purposes only and is not intended to exhibit actual alignment measurements.",
  },

  toeContent: {
    intro: "The toe angle is the most significant factor in extending the life of your tires, maintaining good handling and sustaining fuel economy.",
    introPopup: "Touch and slide the arrows back and forth to change the camber alignment.",
    definitionPopup: `<p>Toe angle is the extent to which your tires are pointed (inward or outward in relation to the centerline of the vehicle when viewed from above.<br><br>Toe can get knocked out of alignment in instances such as running into curbs, driving over potholes, or from normal wear and tear over time.</p>`,
    frontSlider: "Front toe angle",
    rearSlider: "Rear toe angle",
    passImage: toePass,
    failImage: toeFail,
    tireImage: tireNormal,
    toeTireImageRight: tireToeWearRight,
    toeTireImageLeft: tireToeWearLeft,
    disclaimer: "Image is exaggerated for demonstration purposes only and is not intended to exhibit actual alignment measurements.",
    toe1: toe1,
    toe2: toe2,
    toe3: toe3,
    toe4: toe4
  },

  alignmentContent: [
    {icon: seatbelt, alt: "icon of a person sitting in a car seat with their hands on the wheel and seat buckled", text: "Feel safer on the road by restoring vehicle handling."},
    {icon: gasPump, alt: "icon of a gas pump, the pump is in the air ready to fill a car", text: "Optimize fuel efficiency by reducing drag."},
    {icon: wrench, alt: "icon of a wrench suggesting imagery of fixing or repairs", text: "Avoid expensive repairs from undue stress on steering and suspension."},
    {icon: speedometer, alt: "icon of a meter, it looks similar to a speedometer or fuel gauge. the gauge pointer is at the one spot from the end", text: "Extend tire life and protect your investment."}
  ],

  valuePromiseContent: {
    checkmark: greenCheck,
    title: "Our Best Wheel Alignment Value Promise",
    subtitle: "Everything we do, we do to. earn your trust. This includes giving you a comprehensive warranty.",
    includedServices: ["FREE visual alignment check", "All alignments come with a 30-day guarantee", "Warranty covers labor costs", "Honored at every Les Schwab location"]
  },

  stoppingToeContent: {
    column1Title: "Tread Wear and Fuel Efficiency",
    column1Content: "Tires are scrubbing along the road, reducing reducing your fuel efficiency and tire tread life.",
    column2Title: "Stopping Distance",
    column2Content: "Stopping distance increases when the tire’s contact to the road is compromised by increased tread wear and poor alignment.",
    popupMessage: "Touch and slide the arrow back and forth to see the effects of poor toe alignment.",
    passImage: toePass,
    failImage: toeFail,
    toe1: toe1,
    toe2: toe2,
    toe3: toe3,
    toe4: toe4
  },

  stoppingCamberContent: {
    column1Title: "Tread Wear and Fuel Efficiency",
    column1Content: "Tires are scrubbing along the road, reducing reducing your fuel efficiency and tire tread life.",
    column2Title: "Stopping Distance",
    column2Content: "Stopping distance increases when the tire’s contact to the road is compromised by increased tread wear and poor alignment.",
    popupMessage: "Touch and slide the arrow back and forth to see the effects of poor camber alignment.",
    passImage: camberPass,
    failImage: camberFail,
    tireImage: tireNormal,
    tireCamberWearLeft: tireCamberWearLeft,
    tireCamberWearRight: tireCamberWearRight,
    camber1: camber1,
    camber2: camber2,
    camber3: camber3,
    camber4: camber4
  },

  adasContent: {
    checkmark: greenCheck1,
    calibrationCases: ["An alignment", "Changes to the suspension", "Changes in tire size", "Auto body repairs"],
    bestAlignmentCases: ["All alignments come with a 30-day guarantee", "Warranty covers labor costs", "Honored at every Les Schwab Tire Center"]
  }
}
